import AppDispatcher from '../utils/AppDispatcher';
import Cookies from 'universal-cookie';
import { actions as ActionTypes } from '../constants/PosConstants';
import PosApi from '../api/PosApi';
import AjaxPromises from '../utils/AjaxPromises';
import NotificationActions from './NotificationActions';

import UserStore from '../stores/UserStore';

import { endPoints as EndPoints } from '../constants/PosConstants';

var PosActions = {

    setSidebarPage:(page) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_SIDEBAR_PAGE,
            data: page
        });
    },

    toggleSidebar:(direction) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_SIDEBAR,
            data : direction
        });
    },

    loadProducts:() => {
        var formData  = UserStore.getApiData();

        var promise = PosApi.loadProducts(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.PRODUCTS_LOADED,
                data: res.Data ? res.Data.products : []
            });
        });
    },

    productHistory:(guest_id) => {
        var formData      = UserStore.getApiData();
        formData.guest_id = guest_id;

        var promise = PosApi.productHistory(formData);

        promise.then(res => {
            if (res.Data) {
                for (var i=0; i<res.Data.length; i++)
                    res.Data[i].uuid = res.Data[i].SerialNo.replace(/[^a-zA-Z0-9]/g, '-')+res.Data[i].PosId;
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.PRODUCT_HISTORY_LOADED,
                data: res.Data ? res.Data : []
            });
        });
    },

    transactionHistory:(guest_id) => {
        var formData      = UserStore.getApiData();
        formData.guest_id = guest_id;
        var promise = PosApi.transactionHistory(formData);

        promise.then(res => {
            if (res.Data) {
                for (var i=0; i<res.Data.length; i++)
                    res.Data[i].uuid = res.Data[i].PosId;
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.TRANSACTION_HISTORY_LOADED,
                data: res.Data ? res.Data : []
            });
        });
    },

    loadProductInformation:(item, shipment_id) => {
        var formData        = UserStore.getApiData();
        formData.ProductId  = item.ProductId;
        formData.SerialNo   = item.SerialNo;
        formData.ShipmentId = shipment_id;

        var promise = PosApi.loadProductInformation(formData);

        promise.then(res => {
            if (res.Result) {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.PRODUCT_DETAILS_LOADED,
                    data: res.Data[0]
                });
            } else {
                PosActions.notification(res.Message, 'error');
            }
        });
    },

    loadAvailableDiscounts:(guest_id, productId) => {
        var formData        = UserStore.getApiData();
        formData.CustId     = guest_id;
        formData.ProductId  = productId;

        var promise = PosApi.loadAvailableDiscounts(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.AVAIL_DISCOUNTS_LOADED,
                data: res.Data
            });
        });
    },

    loadAppliedDiscounts:(shipment_id) => {
        var formData        = UserStore.getApiData();
        formData.InvId      = shipment_id;

        var promise = PosApi.loadAppliedDiscounts(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.APPLIED_DISCOUNTS_LOADED,
                data: res.Data ? res.Data : []
            });
        });
    },

    loadAvailableFeesDonations:() => {
        var formData        = UserStore.getApiData();

        AjaxPromises.POST(EndPoints.AVAILABLE_FEES_DONATIONS, formData)
        .then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.AVAIL_FEESDONATIONS_LOADED,
                data: res.Data
            })
        })
        .catch(res => { NotificationActions.apiError(false, res.responseJSON); });
    },

    getCalculationMethods:() => {
        AjaxPromises.POST(EndPoints.GET_CALCULATION_METHODS)
        .then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.CALCULATION_METHODS_LOADED,
                data: res.Data
            })
        })
        .catch(res => { NotificationActions.apiError(false, res.responseJSON); });
    },

    getAvailabelLabels:(formData) => {
        var promise = PosApi.getAvailabelLabels(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.LABELS_LOADED,
                data : { labels: res.Data }
            });
        });
    },

    setAutoPrintLabels:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AUTO_PRINT_LABELS,
            data: val
        });
    },

    getBuildNumber:() => {
        AjaxPromises.GET('api/admin/get-build-number').then(res => {
            AppDispatcher.dispatch({
                actionType : ActionTypes.BUILD_NUMBER,
                data: {
                    number: res.BuildNumber,
                    forceRefresh: res.ForceRefresh,
                },
            });
        });
    },

    getRegion:() => {
        AjaxPromises.GET('api/admin/get-region').then(res => {
            AppDispatcher.dispatch({
                actionType : ActionTypes.REGION,
                data: res.Data,
            });
        });
    },

    getSSOLoginEnabled:() => {
        AjaxPromises.GET('api/saml/SSOLoginEnabled').then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.SSO_LOGIN_ENABLED,
                data: res.isSSOLoginEnabled,
            });
        })
    },

    getCurrentServer:() => {
        AjaxPromises.GET('api/admin/current-server').then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.CURRENT_SERVER,
                data: res.Data,
            });
        })
    },

    setAutoPrintReceipts:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AUTO_PRINT_RECEIPTS,
            data: val
        });
    },

    setDefaultLabel:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_DEFAULT_LABEL,
            data: val
        });
    },

    setReceiptPrinter:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RECEIPT_PRINTER,
            data: val
        });
    },

    setLabelPrinter:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_LABEL_PRINTER,
            data: val
        });
    },

    assignRegister:(register) => {
        var hardwareId = uuid();
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        var cookies = new Cookies();
        cookies.set('LeafLogixHardwareData', { hardwareId }, { path: '/', expires: expires });

        var data = UserStore.getApiData(register);
        data.hardwareId = hardwareId;

        return AjaxPromises.POST('api/posv3/registers/assign', data);
    },

    popUpNotes:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.POP_UP_NOTES,
            data: val
        });
    },

    setInitialLoad:(val) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_INITIAL_LOAD,
            data: val
        });
    },

    productSearch:(formData, CustomerId) => {
        PosApi.productSearch(UserStore.getApiData({
            SearchString : '',
            CustomerId
        })).then(res => {
            if (res.Data)
                for (var i=0; i<res.Data.length; i++)
                    res.Data[i].uuid = res.Data[i].SerialNo.replace(/[^a-zA-Z0-9]/g, '-')+res.Data[i].InvId;

            AppDispatcher.dispatch({
                actionType: ActionTypes.PRODUCT_SEARCH,
                data: res.Data ? res.Data : []
            });
        });
    },

    setGuestListSorting(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GUEST_LIST_SORTING,
            data: data
        });
    },

    notification(message, type) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type : type,
                body : message
            });
        }, 100);
    }
}

export default PosActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/PosActions.jsx